import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getPathName } from "../../../common/utils/utilsFunc";

export const UpdateContactInformationContext = createContext();

export const ACTIONS = {
  SET_WEB_CONTENT_TEXT_TITLE: "SET_WEB_CONTENT_TEXT_TITLE" ,
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
  SET_CTA_CTO: "SET_CTA_CTO",
  SET_RESPONSE_SERV1: "SET_RESPONSE_SERV1", 
  SET_RESPONSE_SERV2: "SET_RESPONSE_SERV2" 
};

const initialState = {
  webContentTextTitle:null,
  webContentTextInfo:null,
  ctaCto:null,
  form:null,
  response_serv1:null,
  response_serv2:null
};
const UpdateContactInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_WEB_CONTENT_TEXT_TITLE: {
      return {
          ...state,
          webContentTextTitle: action.payload,
          };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
          ...state,
          webContentTextInfo: action.payload,
          };
    }
    case ACTIONS.SET_CTA_CTO: {
      return {
          ...state,
          ctaCto: action.payload,
          };
    }
    case ACTIONS.SET_RESPONSE_SERV1: {
      return {
          ...state,
          response_serv1: action.payload,
          };
    }
    case ACTIONS.SET_FORM: {
      return {
          ...state,
          form: action.payload,
          };
    }
    case ACTIONS.SET_RESPONSE_SERV2: {
      return {
          ...state,
          response_serv2: action.payload,
          };
    }
    default: {
      return state;
    }
  }
};
const UpdateContactInformationContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(UpdateContactInformationReducer, initialState);

  useEffect(() => {
    if (getPathName() === 'para-estar-informados-completa-tus-datos') {
          
      if(properties.web_content_title_update_of_contact_information){
        LiferayService.getWebContent(properties.base_url_api,properties.web_content_title_update_of_contact_information)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_TITLE,
          });
        })
      }
      if(properties.web_content_info_update_of_contact_information_no_aux_text){
        LiferayService.getWebContent(properties.base_url_api,properties.web_content_info_update_of_contact_information_no_aux_text)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }
     
    }
  }, []);


  useEffect(() => {
    if (getPathName() === 'para-estar-informados-completa-tus-datos') {
          
      if(state.ctaCto){
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.ctaCto, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_SERV1,
          });
        })
      }
       
     
    }
  }, [state.ctaCto]);

  useEffect(() => {
    if (getPathName() === 'para-estar-informados-completa-tus-datos') {
          
      if(state.form){
        LiferayService.editContactClient(properties.base_url_api,state.form, properties.codigo_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_SERV2,
          });
        })
      }
       
     
    }
  }, [state.form]);
  
  
  return (
    <UpdateContactInformationContext.Provider value={[state, dispatch]}>
      {children}
    </UpdateContactInformationContext.Provider>
  );
};
export default UpdateContactInformationContextProvider;